export default __webpack_public_path__ + "static/media/plasticChair.7cb27fca.png";